// YAML plain scalars break on `: `, on a trailing ` #`, and on a leading
// indicator character. Generator inputs are free text a teacher typed (a topic
// like "Animals: pets", a translation like "книга: підручник"), so quote
// defensively rather than hoping. Commas are safe outside flow context.
//
// Quote the whole composed value, never an interpolated fragment of it:
// `name: ${yamlScalar(topic)} spelling` would emit `name: "Animals: pets"
// spelling`, which is still broken.
export const yamlScalar = (value) =>
  /(^[-?:,[\]{}#&*!|>'"%@`])|(:\s)|(\s#)/.test(value) ? JSON.stringify(value) : value
